import { render, staticRenderFns } from "./YourActivities.vue?vue&type=template&id=84e4b936"
import script from "./YourActivities.vue?vue&type=script&lang=js"
export * from "./YourActivities.vue?vue&type=script&lang=js"
import style0 from "./YourActivities.vue?vue&type=style&index=0&id=84e4b936&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports